import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../Api";

export const getMappedFields = createAsyncThunk("mappedFields", async (d) => {
  try {
    const res = await api.get(`${process.env.REACT_APP_BASE_URL}/map/all`);
    return { data: res.data.results };
  } catch (error) {
    throw error;
  }
});

const mappedFieldSlice = createSlice({
  name: "schedule",
  initialState: {
    data: [],
    isLoading: false,
    isError: false,
    isSuccess: false,
    errMsg: "",
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getMappedFields.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getMappedFields.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload.data;
    });
    builder.addCase(getMappedFields.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.errMsg = "Error Occurred";
    });
  },
});

export const mappedFieldsReducer = mappedFieldSlice.reducer;
